import "./TradingIdeasConfidenceComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IRootElementService} from "angular";
import {ReplaySubject, Scheduler} from "rxjs";
import {TradingIdeasViewStore} from "../../store/TradingIdeasViewStore";
import {IdeaInfoDialogService} from "../info/services/IdeaInfoDialogService";

export const Confidence = "tfTradingIdeasConfidence";

export function confidence(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/confidence/TradingIdeasConfidenceComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasConfidenceComponentController
    };
}

export class TradingIdeasConfidenceComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    public readonly points$ = new ReplaySubject<string>(1);
    public readonly confidence$ = new ReplaySubject<string>(1);

    private readonly openInfo$ = new ReplaySubject<boolean>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly ideaInfoDialogService: IdeaInfoDialogService) {

    }

    public $onInit(): void {
        this.watchConfidence();
        this.watchOpenInfo();
    }

    private watchConfidence() {
        const confidence$ = this.store
                                .currentModel
                                .takeUntil(this.destroyed$)
                                .observeOn(Scheduler.async)
                                .map((m) => m.confidence)
                                .shareReplay();

        confidence$.map((m) => m.confidence)
                   .map((c) => c * 100)
                   .map((p) => p.toFixed(0))
                   .subscribe((points) => this.points$.next(points));

        confidence$.map((m) => m.level)
                   .map((level) => level.toLocaleLowerCase())
                   .subscribe((level) => this.confidence$.next(level));

    }

    private watchOpenInfo() {
        this.openInfo$
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .withLatestFrom(this.store.currentModel)
            .map(([_, model]) => model)
            .subscribe((model) => this.ideaInfoDialogService.open(model));
    }

    public showIdeaInfo(): void {
        this.openInfo$.next(true);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
